import StartupCustomers from './customers';
import StartupCustomerFilters from './customer-filters';
import FavouritePageNodes from './favourite-page-nodes';
import UserSpaceConversationLabels from './user-space-conversation-labels';
import UserPlan from './plan';
import Banking from './banking';
import ReferralsAndRewards from './referrals-and-rewards';
import CustomerLabels from './customer-labels';
import AskAIToGeneratePageTasks from './ask-ai-to-generate-page-tasks';

class StartupUsers {

  constructor(basePath, baseStartupUserPath, apiClient) {

    this.basePath = `${basePath}/users`;
    this.currentUserBasePath = baseStartupUserPath;
    this.apiClient = apiClient;

    this.customers = new StartupCustomers(this.currentUserBasePath, this.apiClient);
    this.customerFilters = new StartupCustomerFilters(basePath, this.currentUserBasePath, this.apiClient);
    this.favouritePageNodes = new FavouritePageNodes(this.currentUserBasePath, this.apiClient);
    this.userSpaceConversationLabels = new UserSpaceConversationLabels(this.currentUserBasePath, this.apiClient);
    this.plan = new UserPlan(this.currentUserBasePath, this.apiClient);
    this.banking = new Banking(this.currentUserBasePath, this.apiClient);
    this.referralsAndRewards = new ReferralsAndRewards(this.currentUserBasePath, this.apiClient);
    this.customerLabels = new CustomerLabels(this.currentUserBasePath, this.apiClient);
    this.askAIToGeneratePageTasks = new AskAIToGeneratePageTasks(this.currentUserBasePath, this.apiClient);

  }

  async getPaginatedStartupUsersByQueryOptions(queryOptions) {

    const path = this.basePath;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getPaginatedStartupUsersByQueryOptionsPrivate(queryOptions) {

    const path = `${this.basePath}/private`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async getStartupUserContactsByQueryOptions(queryOptions) {

    const path = `${this.currentUserBasePath}/contacts`;

    return this.apiClient.get(path, {}, queryOptions);

  }

  async askAI(message) {

    const path = `${this.currentUserBasePath}/ask-ai`;

    return this.apiClient.post(path, {}, {}, message);

  }

  async getAssistantAuthorization() {

    const path = `${this.currentUserBasePath}/assistant-authorization`;

    return this.apiClient.get(path, {}, {});

  }

  async pinConversation(conversationId) {

    const path = `${this.currentUserBasePath}/pinned-conversations/:conversationId`;

    return this.apiClient.post(path, { conversationId }, {}, {});

  }

  async unpinConversation(conversationId) {

    const path = `${this.currentUserBasePath}/pinned-conversations/:conversationId`;

    return this.apiClient.delete(path, { conversationId }, {}, {});

  }

  async setAssistantConversationContentAndAttachments(data) {

    const path = `${this.currentUserBasePath}/assistant-conversation-content-and-attachments`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async setAssistantConversationContent(data) {

    const path = `${this.currentUserBasePath}/assistant-conversation-content`;

    return this.apiClient.put(path, {}, {}, data);

  }

  async sendUserToAssistantMessage(data) {

    const path = `${this.currentUserBasePath}/assistant-messages`;

    return this.apiClient.post(path, {}, {}, data);

  }

}

export default StartupUsers;